import React from 'react'
import styles from './styles.css'
import Input from './Input'
import Actions from './Actions'
import useState from 'App/hooks/useState'

export default function NewMessage({conversationId, refetchMessages}) {
  const [text, setText] = useState()
  return (
    <div className={styles.container}>
      <Input
        conversationId={conversationId}
        text={text}
        setText={setText}
        refetchMessages={refetchMessages}
      />
      <Actions conversationId={conversationId} text={text} setText={setText} />
    </div>
  )
}
